var $fa5f88e804986547$exports = {};
$fa5f88e804986547$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Valoarea trebuie s\u0103 fie ".concat(args.maxValue, " sau anterioar\u0103.");
  },
  "rangeReversed": "Data de \xEEnceput trebuie s\u0103 fie anterioar\u0103 datei de sf\xE2r\u0219it.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Valoarea trebuie s\u0103 fie ".concat(args.minValue, " sau ulterioar\u0103.");
  },
  "unavailableDate": "Data selectat\u0103 nu este disponibil\u0103."
};
export { $fa5f88e804986547$exports as default };